export function applyAccountRules(state) {
    const hiddenFields = new Set();
    const requiredFields = new Set([
        'name', 'ownerUserId', 'accountType', 'industry', 'phone',
        'billingCountry', 'leadSource', 'estimatedProjectValue'
    ]);
    const warnings = [];

    if (state.accountType === 'prospect') {
        hiddenFields.add('accountNumber');
        requiredFields.add('rating');
    }

    if (state.accountType === 'partner') {
        hiddenFields.add('annualRevenue');
    }

    return { hiddenFields, requiredFields, warnings };
}

export function applyDealRules(state) {
    const hiddenFields = new Set();
    const requiredFields = new Set();
    const warnings = [];

    if (state.dealType === 'renewal') {
        hiddenFields.add('leadSource');
    }

    if (state.stage === 'proposal' || state.stage === 'negotiation' || state.stage === 'closed') {
        const roles = state.dealContactRoles || [];
        if (!roles.length || !roles.some(r => r.contactId && r.role)) {
            // Soft guidance before Closed Won; Closed Won enforces this as a hard error in DealFormValidator.
            warnings.push('Add at least one contact with a role for deals at this stage.');
        } else if (!roles.some(r => r.role === 'decision_maker')) {
            warnings.push('A Decision Maker contact is recommended.');
        }
    }

    return { hiddenFields, requiredFields, warnings };
}
